"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3411,5790],{

/***/ 362371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getFooterDSLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(693967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var getFooterDSLabel = function(param) {
    var configs = param.configs, _prefix = param.prefix, prefix = _prefix === void 0 ? "" : _prefix, _suffix = param.suffix, suffix = _suffix === void 0 ? "" : _suffix, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? {} : _customStyles;
    var ref;
    var showDsLabel = !!((ref = configs === null || configs === void 0 ? void 0 : configs.ds_branding_flag) !== null && ref !== void 0 ? ref : 1);
    if (showDsLabel) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                prefix ? "".concat(prefix, " powered") : "Powered",
                " by \xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: "https://download.digitalshowroom.app/download-cfe",
                    target: "_blank",
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("underline copyright-text-grey-color tw-cursor-pointer", customClasses),
                    rel: "website app link noreferrer",
                    style: customStyles,
                    children: [
                        "Digital Showroom ",
                        suffix
                    ]
                })
            ]
        });
    }
    return null;
};


/***/ }),

/***/ 903411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer2_Footer2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(737179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(842757);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(720901);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer2/Footer2.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  &.bg_type_image {\n    background: ",
        ";\n    background-size: cover;\n    background-position: center;\n  }\n  &.bg_type_solid {\n    background: ",
        ";\n  }\n  &.bg_type_image::after {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: ",
        ";\n    z-index: 1;\n  }\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 2.5rem 4rem;\n  display: flex;\n  z-index: 10;\n  position: relative;\n  & .left-container {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n    flex: 1;\n  }\n  & .left-container .addressContainer {\n    display: flex;\n    flex-wrap: wrap;\n    text-align: left;\n    font-size: 0.813rem;\n    font-weight: 500;\n    line-height: 22px;\n    width: 80%;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .left-container .addressContainer .address {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    color: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .left-container .addressContainer .address .contact {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .logo-container {\n    display: flex;\n    justify-content: flex-start;\n  }\n  & .middle-container {\n    flex: 0.8;\n    align-items: center;\n  }\n  & .right-container {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n  }\n  & .middle-container .privacy-terms-container {\n    display: flex;\n    gap: 1.5rem;\n    font-size: 0.875rem;\n    text-align: center;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .middle-container .privacy-terms-container .privacy-policy {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  & .right-container {\n    align-items: flex-end;\n    flex: 0.6;\n  }\n  & .right-container .footer-rights-container {\n    text-align: right;\n    display: flex;\n    flex-direction: column;\n    gap: 0.563rem;\n    opacity: 0.6;\n  }\n  & .right-container .social-media-section {\n    display: flex;\n    justify-content: space-between;\n  }\n  & .right-container .footer-rights-container .copyright,\n  & .right-container .footer-rights-container .copyright-sub-text {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    font-style: normal;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    opacity: 0.6;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .right-container .footer-rights-container .copyright {\n    font-size: 0.75rem;\n  }\n  & .right-container .footer-rights-container .copyright-sub-text {\n    font-size: 0.625rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 2.5rem 1rem;\n  flex-direction: column;\n  gap: 2.5rem;\n  z-index: 10;\n  position: relative;\n  & > .first-container {\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  & .first-container .privacy-terms-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    font-size: 0.875rem;\n    text-align: left;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & > .second-container .social-media-section {\n    display: flex;\n    justify-content: flex-start;\n  }\n  & .third-container .addressContainer {\n    display: flex;\n    flex-wrap: wrap;\n    text-align: left;\n    font-size: 0.813rem;\n    line-height: 22px;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .third-container .addressContainer .address {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .third-container .addressContainer .address .contact {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & > .fourth-container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n  }\n  & > .fifth-container .footer-rights-container .copyright,\n  & > .fifth-container .footer-rights-container .copyright-sub-text {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    opacity: 0.6;\n    font-style: normal;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & > .fifth-container .footer-rights-container .copyright {\n    font-size: 0.75rem;\n  }\n  & > .fifth-container .footer-rights-container .copyright-sub-text {\n    font-size: 0.625rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterContainer",
    componentId: "sc-3cc06a9d-0"
})(_templateObject(), function(props) {
    var ref, ref1, ref2, ref3, ref4;
    return ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.image_url) ? "url(".concat((ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.propsBackground) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.image_url, ")") : "none, ".concat((props === null || props === void 0 ? void 0 : (ref4 = props.propsBackground) === null || ref4 === void 0 ? void 0 : ref4.default) || (props === null || props === void 0 ? void 0 : props.themeBackground));
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* FOOTER_OPACITY */.he, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
});
var FooterDesktopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterDesktopContainer",
    componentId: "sc-3cc06a9d-1"
})(_templateObject1(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
});
var FooterMobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterMobileContainer",
    componentId: "sc-3cc06a9d-2"
})(_templateObject2(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
});

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/Footer/utils/commonGetterFunction.js
var commonGetterFunction = __webpack_require__(605790);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer2/Components/FooterDesktop.js



var FooterDesktop = function(props) {
    var footerState = props.footerState, store = props.store, propStyle = props.propStyle, handleLogoClick = props.handleLogoClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterDesktopContainer, {
        themeBackground: propStyle,
        className: "footerDesktopContainer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "logo-container",
                        children: (0,commonGetterFunction/* getStoreLogo */.B9)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements, handleLogoClick)
                    }),
                    (0,commonGetterFunction/* getAddressDetails */.IL)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "middle-container",
                children: (0,commonGetterFunction/* getSpecificPageVisibleItems */.Ds)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "right-container",
                children: [
                    (0,commonGetterFunction/* getActiveSocialMedia */.dw)(store),
                    (0,commonGetterFunction/* getFooterRightReservedtext */.E2)()
                ]
            })
        ]
    });
};
/* harmony default export */ var Components_FooterDesktop = (FooterDesktop);

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer2/Components/FooterMobile.js



var FooterMobile = function(props) {
    var footerState = props.footerState, store = props.store, propStyle = props.propStyle, handleLogoClick = props.handleLogoClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterMobileContainer, {
        themeBackground: propStyle,
        className: "footerMobileContainer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "first-container",
                children: (0,commonGetterFunction/* getSpecificPageVisibleItems */.Ds)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "second-container",
                children: (0,commonGetterFunction/* getActiveSocialMedia */.dw)(store)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "third-container",
                children: (0,commonGetterFunction/* getAddressDetails */.IL)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fourth-container",
                children: (0,commonGetterFunction/* getStoreLogo */.B9)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements, handleLogoClick)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fifth-container",
                children: (0,commonGetterFunction/* getFooterRightReservedtext */.E2)()
            })
        ]
    });
};
/* harmony default export */ var Components_FooterMobile = (FooterMobile);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer2/Footer2.js











var Footer2 = function(props) {
    var ref, ref1, ref2, ref3;
    var isAlreadyTransformed = props.isAlreadyTransformed;
    var ref4 = (0,react.useState)(isAlreadyTransformed ? props.footerState : (0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), footerState = ref4[0], setFooterState = ref4[1];
    (0,react.useEffect)(function() {
        var ref;
        setFooterState(isAlreadyTransformed ? props.footerState : (0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children));
    }, [
        props
    ]);
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref5 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.style_template), propStyle = ref5[0], setPropStyle = ref5[1];
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.style_template
    ]);
    var router = (0,next_router.useRouter)();
    var handleLogoClick = function() {
        var ref;
        return router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var ref6 = (0,react.useState)(true), IS_DESKTOP = ref6[0], setIS_DESKTOP = ref6[1];
    var checkWindowSize = function() {
        if (true) {
            var isMobile = window.innerWidth < 768; // You can adjust this threshold
            setIS_DESKTOP(!isMobile);
        }
    };
    (0,react.useEffect)(function() {
        // Check window size on component mount
        checkWindowSize();
        // Add event listener for window resize only on the client side
        var handleResize = function() {
            checkWindowSize();
        };
        if (true) {
            window.addEventListener("resize", handleResize);
            // Cleanup the event listener on component unmount
            return function() {
                window.removeEventListener("resize", handleResize);
            };
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
        id: "Footer2",
        propsBackground: footerState === null || footerState === void 0 ? void 0 : (ref3 = footerState.media) === null || ref3 === void 0 ? void 0 : ref3.background,
        themeBackground: propStyle,
        className: "modern_theme_footer2 bg_type_solid",
        children: IS_DESKTOP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_FooterDesktop, {
            store: storeData,
            footerState: footerState,
            setFooterState: setFooterState,
            propStyle: propStyle,
            handleLogoClick: handleLogoClick
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_FooterMobile, {
            store: storeData,
            footerState: footerState,
            setFooterState: setFooterState,
            propStyle: propStyle,
            handleLogoClick: handleLogoClick
        })
    });
};
/* harmony default export */ var Footer2_Footer2 = (Footer2);


/***/ }),

/***/ 605790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ getStoreLogo; },
/* harmony export */   "Ds": function() { return /* binding */ getSpecificPageVisibleItems; },
/* harmony export */   "E2": function() { return /* binding */ getFooterRightReservedtext; },
/* harmony export */   "Eb": function() { return /* binding */ getDescription; },
/* harmony export */   "IL": function() { return /* binding */ getAddressDetails; },
/* harmony export */   "dw": function() { return /* binding */ getActiveSocialMedia; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27909);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540190);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17247);
/* harmony import */ var src_components_DesignSystem_Footers_footerUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(362371);






var getStoreLogo = function(storeContent, handleLogoClick) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    return (storeContent === null || storeContent === void 0 ? void 0 : (ref = storeContent.content) === null || ref === void 0 ? void 0 : (ref1 = ref.storeDetails) === null || ref1 === void 0 ? void 0 : ref1.store_logo_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: "store_logo_image",
        src: (ref2 = storeContent.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.storeDetails) === null || ref3 === void 0 ? void 0 : ref3.store_logo_url,
        alt: "store_logo",
        width: (storeContent === null || storeContent === void 0 ? void 0 : (ref4 = storeContent.content) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.storeDetails) === null || ref5 === void 0 ? void 0 : ref5.store_logo_size) ? "".concat(parseInt((ref6 = storeContent.content) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.storeDetails) === null || ref7 === void 0 ? void 0 : ref7.store_logo_size), "px") : "0px",
        height: (storeContent === null || storeContent === void 0 ? void 0 : (ref8 = storeContent.content) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.storeDetails) === null || ref9 === void 0 ? void 0 : ref9.store_logo_size) ? "".concat(parseInt((ref10 = storeContent.content) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.storeDetails) === null || ref11 === void 0 ? void 0 : ref11.store_logo_size), "px") : "0px",
        onError: function(e) {
            var ref, ref1;
            return e.target.src = (ref = storeContent.content) === null || ref === void 0 ? void 0 : (ref1 = ref.storeDetails) === null || ref1 === void 0 ? void 0 : ref1.store_logo_url;
        },
        onClick: handleLogoClick,
        style: {
            cursor: "pointer"
        },
        loading: "lazy"
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "store_logo_name",
        children: _redux_store__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getState */ .Z.getState().storeReducer.store.store_name
    });
};
var getSpecificPageVisibleItems = function(footerContent) {
    var ref, ref1, ref2, ref3;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "privacy-terms-container",
        children: [
            (footerContent === null || footerContent === void 0 ? void 0 : (ref = footerContent.content) === null || ref === void 0 ? void 0 : (ref1 = ref.pageDetailsVisibility) === null || ref1 === void 0 ? void 0 : ref1.privacyPolicy) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "privacy-policies",
                onClick: function() {
                    return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_1__/* .handleRouteChangesOnClick */ .Z)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.STORE_POLICIES, {
                        page_type: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE */ .rl === null || _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE */ .rl === void 0 ? void 0 : _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE.POLICY */ .rl.POLICY
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: "Privacy Policy"
            }),
            (footerContent === null || footerContent === void 0 ? void 0 : (ref2 = footerContent.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageDetailsVisibility) === null || ref3 === void 0 ? void 0 : ref3.termsAndConditions) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "terms-conditions",
                onClick: function() {
                    return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_1__/* .handleRouteChangesOnClick */ .Z)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.STORE_POLICIES, {
                        page_type: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE */ .rl === null || _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE */ .rl === void 0 ? void 0 : _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE.TNC */ .rl.TNC
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: "Terms & Conditions"
            })
        ]
    });
};
var getAddressDetails = function(footerContent) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "addressContainer",
        children: ((footerContent === null || footerContent === void 0 ? void 0 : (ref = footerContent.content) === null || ref === void 0 ? void 0 : (ref1 = ref.storeDetails) === null || ref1 === void 0 ? void 0 : ref1.address) || (footerContent === null || footerContent === void 0 ? void 0 : (ref2 = footerContent.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.storeDetails) === null || ref3 === void 0 ? void 0 : ref3.phone) || (footerContent === null || footerContent === void 0 ? void 0 : (ref4 = footerContent.content) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.storeDetails) === null || ref5 === void 0 ? void 0 : ref5.email)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "address",
            children: [
                footerContent === null || footerContent === void 0 ? void 0 : (ref6 = footerContent.content) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.storeDetails) === null || ref7 === void 0 ? void 0 : ref7.address,
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "contact",
                    children: [
                        (footerContent === null || footerContent === void 0 ? void 0 : (ref8 = footerContent.content) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.storeDetails) === null || ref9 === void 0 ? void 0 : ref9.phone) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                "Phone ",
                                footerContent === null || footerContent === void 0 ? void 0 : (ref10 = footerContent.content) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.storeDetails) === null || ref11 === void 0 ? void 0 : ref11.phone
                            ]
                        }),
                        " ",
                        (footerContent === null || footerContent === void 0 ? void 0 : (ref12 = footerContent.content) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.storeDetails) === null || ref13 === void 0 ? void 0 : ref13.email) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: "\xa0| \xa0"
                        }),
                        " ",
                        (footerContent === null || footerContent === void 0 ? void 0 : (ref14 = footerContent.content) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.storeDetails) === null || ref15 === void 0 ? void 0 : ref15.email) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                "Email ",
                                footerContent === null || footerContent === void 0 ? void 0 : (ref16 = footerContent.content) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.storeDetails) === null || ref17 === void 0 ? void 0 : ref17.email
                            ]
                        }),
                        " "
                    ]
                })
            ]
        })
    });
};
var getActiveSocialMedia = function(store) {
    var ref, ref1;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "social-media-section",
        style: {
            gap: "16px"
        },
        children: store === null || store === void 0 ? void 0 : (ref = store.social_media_profile_details) === null || ref === void 0 ? void 0 : (ref1 = ref.media_detail) === null || ref1 === void 0 ? void 0 : ref1.map(function(profile) {
            return profile.profile_url !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "social-media-icon",
                style: {
                    height: "24px",
                    width: "24px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: profile.profile_url,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: profile.image_url,
                        alt: "".concat(profile === null || profile === void 0 ? void 0 : profile.name, " image")
                    })
                })
            }, profile.id) : null;
        })
    });
};
var getFooterRightReservedtext = function() {
    var ref, ref1, ref2, ref3;
    var currentYear = new Date().getFullYear();
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var footerConfig = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Footer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.config;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "footer-rights-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "copyright",
                children: [
                    "\xa9 ",
                    storeData.store_name || "Brand Name",
                    ". All Rights Reserved ",
                    currentYear
                ]
            }),
            !(footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.hide_ds_label) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "copyright-sub-text",
                children: (0,src_components_DesignSystem_Footers_footerUtils__WEBPACK_IMPORTED_MODULE_5__/* .getFooterDSLabel */ .m)({
                    configs: storeData === null || storeData === void 0 ? void 0 : storeData.configs,
                    prefix: "Website",
                    customClasses: "!tw-no-underline !tw-text-inherit !tw-opacity-100"
                })
            })
        ]
    });
};
var getDescription = function(footerContent) {
    var ref, ref1;
    return (footerContent === null || footerContent === void 0 ? void 0 : (ref = footerContent.description) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "footer-description",
        children: footerContent === null || footerContent === void 0 ? void 0 : (ref1 = footerContent.description) === null || ref1 === void 0 ? void 0 : ref1.text
    });
};


/***/ }),

/***/ 27909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ handleRouteChangesOnClick; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(540190);



var handleRouteChangesOnClick = function(routePath) {
    var additionalQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
        pathname: (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(routePath, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain),
        query: additionalQuery
    });
};


/***/ })

}]);